import { Label } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import React from 'react';
import BordereauStateFactory from '../../../../classes/bordereaux/state/BordereauStateFactory';

import type BordereauStateType from '../../../../constants/liquidation/bordereaux/BordereauStateType';
import './Bordereau.css';

interface FiltresBordereauProps {
	onChange: (bordereauStateType: number) => void;
	value: number | null;
	/** États des bordereaux chargés, null tant qu'ils ne sont pas connus. */
	visibleStates: Set<BordereauStateType> | null;
}
const FiltresBordereauState = ({
	onChange,
	value,
	visibleStates,
}: FiltresBordereauProps) => {
	if (!visibleStates?.size) {
		return null;
	}

	return (
		<Combobox
			options={BordereauStateFactory.getAllStates()
				.filter((state) => visibleStates.has(state.state))
				.map((state) => ({
					key: state.step,
					value: state.step,
					'data-testid': `filtreBordereauStateComboboxOption${state.step}`,
					text: (
						<Label
							horizontal
							style={{
								backgroundColor: state.color,
							}}
							size="medium"
							className="bordereau-label"
						>
							{state.libelle}
						</Label>
					),
				}))}
			placeholder="Tous les états"
			value={value ?? ''}
			clearable
			onChange={(_e, { value }: { value: number }) => onChange(value)}
			data-testid="filtreBordereauStateCombobox"
		/>
	);
};

export default FiltresBordereauState;
